import React from 'react';
import { Tooltip, Icons } from '@myob/myob-widgets';
import { StatusElementContainer, TooltipWrapper } from '../../style';
import { Label } from '@myob/myob-widgets';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { TProduct } from 'modules/ProductManagement/reducers/type';
import { ESubscriptionStatus } from '../../type';
import { capitalise } from '../../helper';
import { getFirstElementInProductList } from '../../reducers/accessors';

export const statusMapper = [
    {
        status: ESubscriptionStatus.ACTIVE,
        color: 'green',
        tooltipMessage: 'Your subscription is up to date.',
    },
    {
        status: ESubscriptionStatus.TRIAL,
        color: 'blue',
        tooltipMessage: 'Try all features for free for 30 days.',
    },
    {
        status: ESubscriptionStatus.PAYMENT_FAILED,
        color: 'red',
        tooltipMessage: "We couldn't process payment. Edit details or contact us.",
    },
    {
        status: ESubscriptionStatus.EXPIRED,
        color: 'orange',
        tooltipMessage: 'Your subscription is over. Contact us to continue!',
    },
];

const Status: React.FC = () => {
    const { status } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    const color = statusMapper.find(item => item.status === status)?.color;
    const tooltipMessage = statusMapper.find(item => item.status === status)?.tooltipMessage;
    const capitalizedStatus = capitalise(status);
    return (
        <>
            <StatusElementContainer>
                <div>
                    <h6 className="statusLabel">Status</h6>
                    <Label type="boxed" size="large" color={color} className="status" data-testid="status">
                        {capitalizedStatus}
                    </Label>
                </div>
                <TooltipWrapper>
                    <Tooltip
                        triggerContent={<Icons.Help />}
                        placement="bottom"
                        trigger="click"
                        className="status-tooltip"
                    >
                        {tooltipMessage}
                    </Tooltip>
                </TooltipWrapper>
            </StatusElementContainer>
        </>
    );
};

export default Status;
